import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { OrderButton } from './OrderButton';
import { AmbientLight } from './AmbientLight';
import { ScrollBacklight } from './ScrollBacklight';
import { ORDER_URL } from '../constants/translations';
import { useLanguage } from '../context/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative bg-texture-dark text-cream pt-32 lg:pt-44 pb-32 lg:pb-40 overflow-hidden" data-id="element-176" data-mp="129qudld1bpnv">
      <AmbientLight variant="top" data-id="element-177" data-mp="xaxj7zl80aqv" />

      <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 left-8 flex-col items-center gap-6 text-[9px] tracking-[0.5em] uppercase text-cream/35" data-id="element-178" data-mp="sbb1bcug66bq">
        <span style={{
        writingMode: 'vertical-rl'
      }} className="rotate-180" data-id="element-179" data-mp="nbosrgpkde99">
          {t.hero.sideLeft}
        </span>
        <span className="w-px h-16 bg-cream/15" data-id="element-180" data-mp="381e25e7i07uk" />
      </div>
      <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 right-8 flex-col items-center gap-6 text-[9px] tracking-[0.5em] uppercase text-cream/35" data-id="element-181" data-mp="3j8iwsycd6eu6">
        <span className="w-px h-16 bg-cream/15" data-id="element-182" data-mp="3o73p8bldju82" />
        <span style={{
        writingMode: 'vertical-rl'
      }} data-id="element-183" data-mp="39al869qleg11">
          {t.hero.sideRight}
        </span>
      </div>

      <div className="relative z-10 max-w-[1300px] mx-auto px-8 lg:px-20" data-id="element-184" data-mp="3e7l5nw9dmagj">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1
      }} className="flex items-center justify-center gap-4 text-[10px] tracking-[0.5em] uppercase text-cream/45 mb-10 lg:mb-14" data-id="element-185" data-mp="30gzteqefgyrm">
          <span className="w-12 h-px bg-cream/25" data-id="element-186" data-mp="2hkgibvk2d0sf" />
          <a href={ORDER_URL} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-2.5 rounded-full focus:outline-none focus-visible:ring-1 focus-visible:ring-caramel focus-visible:ring-offset-4 focus-visible:ring-offset-chocolate" data-id="element-187" data-mp="2lkqyg11kl7l0">
            <span className="blink-dot w-1.5 h-1.5 rounded-full bg-caramel shrink-0" aria-hidden data-id="element-188" data-mp="iboyiltrcouw" />
            <span className="font-serif italic text-caramel normal-case tracking-[0.15em] text-[13px] transition-colors duration-500 group-hover:text-cream" data-id="element-189" data-mp="deq6q9xkgtzv">
              {t.hero.eyebrow}
            </span>
          </a>
          <span className="w-12 h-px bg-cream/25" data-id="element-190" data-mp="15zq1lf863d2x" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.2
      }} className="font-serif text-center text-cream font-light leading-[0.88] tracking-[-0.035em]" style={{
        fontSize: 'clamp(60px, 12vw, 190px)'
      }} data-id="element-191" data-mp="111ewfhsthqr1">
          {t.hero.title1}{' '}
          <span className="italic font-extralight" data-id="element-192" data-mp="218tprvkjzaev">{t.hero.title2}</span>
          <br data-id="element-193" data-mp="2697ouo46fa0r" />
          {t.hero.title3}
          <span className="text-caramel" data-id="element-194" data-mp="2b0pmp3awkuhi">.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="mt-10 text-center font-serif italic text-cream/70 text-xl lg:text-2xl max-w-2xl mx-auto leading-[1.4]" data-id="element-195" data-mp="2b20qv489g495">
          {t.hero.tagline}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.5
      }} className="mt-16 lg:mt-20 mx-auto max-w-[560px]" data-id="element-196" data-mp="umppw17ctkyh">
          <div className="text-center mb-6 flex items-center justify-center gap-4 text-[10px] tracking-[0.4em] uppercase text-cream/40" data-id="element-197" data-mp="3vk1k41bzy6yt">
            <span data-id="element-198" data-mp="99xirg8shlgz">{t.hero.plate}</span>
            <span className="w-1 h-1 rounded-full bg-caramel" data-id="element-199" data-mp="9b0eq2kyye3r" />
            <span data-id="element-200" data-mp="3hphcegddh5wk">{t.hero.plateLabel}</span>
          </div>
          <div className="relative" data-id="element-201" data-mp="3hnxs8eoliapi">
            <ScrollBacklight tone="caramel" data-id="element-202" data-mp="3cryzkew8i6ja" />
            <div className="absolute -inset-3 border border-cream/15" aria-hidden data-id="element-203" data-mp="3cp30uockbdts" />
            <div className="relative aspect-[4/5] overflow-hidden bg-espresso" data-id="element-204" data-mp="3mpdhkixt33dp">
              <img src={IMAGES.openBox} alt="An open TARTA box revealing the deeply caramelized Basque cheesecake within" className="w-full h-full object-cover" data-id="element-205" data-mp="3mnagn3v47pu7" />
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-14 lg:mt-20 max-w-xl mx-auto text-center" data-id="element-206" data-mp="19h2rkly91q6i">
          <p className="text-cream/60 leading-[1.85] text-[15px]" data-id="element-207" data-mp="14k3ubujah343">
            {t.hero.subcopy}
          </p>
          <p className="mt-8 text-cream/45 leading-[1.8] text-[13px] tracking-[0.02em] max-w-md mx-auto" data-id="element-208" data-mp="1s9y5m7nymjm8">
            {t.hero.secondary}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="mt-14 lg:mt-16 flex flex-col items-center gap-8" data-id="element-209" data-mp="1j7oylrrwh8dl">
          <OrderButton withSub data-id="element-210" data-mp="bvokdmf0lazm" />
          <a href="#flavors" className="group inline-flex items-center gap-6 text-[11px] tracking-[0.4em] uppercase text-cream" data-id="element-211" data-mp="bssm1wz98kan">
            <span className="w-10 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-16 transition-all duration-500" data-id="element-212" data-mp="29jsedqjyrqv9" />
            <span className="relative font-serif italic text-[15px] tracking-[0.05em] normal-case" data-id="element-213" data-mp="24pxyyzbe5y1z">
              {t.hero.ctaReserve}
            </span>
            <span className="w-10 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-16 transition-all duration-500" data-id="element-214" data-mp="1vrm06a0dftyg" />
          </a>
          <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="text-[10px] tracking-[0.4em] uppercase text-cream/45 hover:text-caramel transition-colors duration-500" data-id="element-215" data-mp="1qqer87mhsoq7">
            {t.hero.ctaFollow}
          </a>
        </motion.div>
      </div>
    </section>;
}